import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyDAUOhIXJBVY2QlrXJ71opvhIRe6oL7aVw",
  authDomain:        "jashbilling.firebaseapp.com",
  projectId:         "jashbilling",
  storageBucket:     "jashbilling.firebasestorage.app",
  messagingSenderId: "1039992594657",
  appId:             "1:1039992594657:web:6eaef523db539e4ef417a0",
  measurementId: "G-NGWLXXDYH2"
};

const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
